import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, from, map, of, switchMap } from 'rxjs';
import { DealerFeature } from '..';
import { DealerApiService } from '../../api/dealer-api.service';
import { actions } from './hyundai-promise.actions';

@Injectable()
export class PageContentEffects {
    protected readonly actions$ = inject(Actions);
    protected readonly store = inject(Store);
    protected readonly dealerApi = inject(DealerApiService);
    loadHyundaiPromise$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadHyundaiPromise),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectDealer)),
            switchMap(([, dealer]) => {
                return !dealer || !dealer.hPromise
                    ? of(actions.loadHyundaiPromiseFailure({ error: 'Dealer is not a Hyundai Promise Partner' }))
                    : from(this.dealerApi.getPagePromise(dealer.slug)).pipe(
                          map((content) => actions.loadHyundaiPromiseSuccess({ content })),
                          catchError((error) => of(actions.loadHyundaiPromiseFailure({ error }))),
                      );
            }),
        );
    });
}
